import { ImageObj } from '@doltech/utils/lib/constants';
import cl from 'classnames';
import * as React from 'react';
import styled from 'styled-components';

import { deviceBreakpoints } from '../../hooks/useDeviceQuery.hook';
import { Typography } from '../DesignSystemV2/Typography';

const Main = styled.div`
  position: relative;
  cursor: pointer;
  display: grid;
  overflow: hidden;
  border-radius: 8px;

  .overlay-shadow {
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000 100%);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
  }

  .text-content {
    display: grid;
    grid-template-rows: 1fr max-content max-content;
    gap: 16px;
    user-select: none;
    white-space: pre-wrap;
    word-break: break-word;
    z-index: 2;
  }
  .image-wrapper {
    user-select: none;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    > img {
      transition: all 0.3s ease;
      z-index: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &.compact {
    width: 120px;
    height: calc(128px * 16 / 9);
    padding: 8px;
    &:hover {
      .image-wrapper {
        > img {
          transform: scale(1.05);
        }
      }
    }
  }

  &.full {
    padding: 58px 16px 32px;
    width: 100vw;
    height: 100%;
    border-radius: 0;

    @media ${deviceBreakpoints.fromTablet} {
      width: calc(calc(100vh - 40px) * 9 / 16);
      height: calc(100vh - 64px);
      border-radius: 4px;
    }
  }
`;

export interface StoryCardItem extends React.HTMLAttributes<HTMLDivElement> {
  id: string;
  title: string;
  image: ImageObj;
  description?: string;
  variant?: 'compact' | 'full';
  className?: string;
}

export const StoryCard = (props: StoryCardItem) => {
  const { title, description, image, variant, className, ...rest } = props;
  return (
    <Main className={cl('story-card', variant, className)} {...rest}>
      <div className="overlay-shadow" />
      <div className="image-wrapper">
        {image?.url && <img src={image?.url} alt={image?.alt || 'story-card'} />}
      </div>

      <div className="text-content">
        <div className="empty" />
        <Typography.Paragraph
          color="white100"
          variant={variant === 'full' ? 'semi-bold/24' : 'semi-bold/14'}
          className="card-title"
          ellipsis={variant === 'compact' ? { rows: 4 } : undefined}
        >
          {title}
        </Typography.Paragraph>

        {variant === 'full' && description && (
          <Typography.Paragraph color="grey30" variant="medium/16" className="card-description">
            {description}
          </Typography.Paragraph>
        )}
      </div>
    </Main>
  );
};
